/**
 * Composant pour les messages de combo et encouragements
 * Style Duolingo avec animations
 * Now with translations support
 */
import React, { useEffect, useState } from 'react';
import { Flame, Zap, Star, Trophy, Sparkles } from 'lucide-react';

const ComboMessage = ({ streak, show, isPerfect = false, t }) => {
  const [visible, setVisible] = useState(false);
  const [message, setMessage] = useState(null);
  
  // Messages with translations support
  const getComboMessages = () => ({
    3: { 
      icon: Flame, 
      text: t?.lesson?.combo3 || 'En feu !', 
      color: 'text-orange-500', 
      bg: 'bg-orange-100' 
    },
    5: { 
      icon: Zap, 
      text: t?.lesson?.combo5 || 'Incroyable !', 
      color: 'text-yellow-500', 
      bg: 'bg-yellow-100' 
    },
    7: { 
      icon: Star, 
      text: t?.lesson?.combo7 || 'Superstar !', 
      color: 'text-purple-500', 
      bg: 'bg-purple-100' 
    },
    10: { 
      icon: Trophy, 
      text: t?.lesson?.combo10 || 'Légendaire !', 
      color: 'text-emerald-500', 
      bg: 'bg-emerald-100' 
    },
    perfect: { 
      icon: Sparkles, 
      text: t?.lesson?.comboPerfect || 'Parfait !', 
      color: 'text-pink-500', 
      bg: 'bg-pink-100' 
    }
  });
  
  useEffect(() => {
    if (!show) {
      setVisible(false);
      return;
    }
    
    const comboMessages = getComboMessages();
    
    // Déterminer le message à afficher
    let msg = null;
    
    if (isPerfect) {
      msg = comboMessages.perfect;
    } else if (streak >= 10) {
      msg = comboMessages[10];
    } else if (streak >= 7) {
      msg = comboMessages[7];
    } else if (streak >= 5) {
      msg = comboMessages[5];
    } else if (streak >= 3) {
      msg = comboMessages[3];
    }
    
    if (msg) {
      setMessage(msg);
      setVisible(true);
      
      // Cacher après 2 secondes
      const timer = setTimeout(() => {
        setVisible(false);
      }, 2000);
      
      return () => clearTimeout(timer);
    }
  }, [streak, show, isPerfect, t]);
  
  if (!visible || !message) return null;
  
  const Icon = message.icon;
  
  // Translated streak message
  const streakMessage = t?.lesson?.comboStreak 
    ? t.lesson.comboStreak.replace('{streak}', streak)
    : `${streak} bonnes réponses d'affilée !`;
  
  const perfectMessage = t?.lesson?.comboPerfectSub || '100% de réussite !';
  
  return (
    <div className="fixed top-1/3 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50 animate-bounce">
      <div className={`${message.bg} ${message.color} px-6 py-4 rounded-2xl shadow-2xl flex items-center gap-3 animate-pulse`}>
        <Icon className="w-8 h-8" />
        <div>
          <div className="text-2xl font-bold">{message.text}</div>
          {!isPerfect && <div className="text-sm opacity-80">{streakMessage}</div>}
          {isPerfect && <div className="text-sm opacity-80">{perfectMessage}</div>}
        </div>
        <Icon className="w-8 h-8" />
      </div>
    </div>
  );
};

export default ComboMessage;
